import * as React from "react"

import { cn } from "@/lib/utils"
import { AiAssist, fieldLabel } from "../AiAssist"

// Every free-text area gets AI writing help (draft / proofread / improve) unless it carries secrets: pass ai={false} to opt out.
const Textarea = React.forwardRef(({ className, ai = true, aiHint = "", aiContext = "", ...props }, ref) => {
  const inner = React.useRef(null);
  const setRef = (el) => { inner.current = el; if (typeof ref === "function") ref(el); else if (ref) ref.current = el; };
  const controlled = props.value !== undefined && typeof props.onChange === "function";
  const showAi = ai && controlled && !props.disabled && !props.readOnly && props.type !== "password";
  const textarea = (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        showAi && "pb-8",
        className
      )}
      ref={setRef}
      {...props} />
  );
  if (!showAi) return textarea;
  return (
    <div className="relative w-full">
      {textarea}
      <div className="absolute bottom-1.5 right-1.5">
        <AiAssist value={props.value || ""} placeholder={props.placeholder || ""} hint={aiHint} context={aiContext} getLabel={() => fieldLabel(inner.current)} size="xs"
          onApply={(text) => { props.onChange({ target: { value: text, name: props.name }, currentTarget: { value: text } }); inner.current?.focus(); }} />
      </div>
    </div>
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
